// extracted by mini-css-extract-plugin
module.exports = {"menu":"More_menu__2FUsE","settings":"More_settings__2nY0g"};